<template>
  <div class="content-wrapper">
    <div class="content-wrapper">
      <div class="container">
        <article>
        <section class="section white-panel mb2p pt24">
          <h2 class="fs16 bdb-solid-gradient1 pb8 mb8">メンテナンスパック利用規約</h2>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第1条（総則）</h3>
            <ol class="ol-count fs13">
              <li>本規約は、コスモ石油マーケティング株式会社（以下「当社」といいます。）が管理するアプリ「【コスモの公式】アプリ」（以下「本アプリ」といいます。）上で提供するメンテナンスパック（以下「本サービス」といいます。）に関し、本サービスを利用される方（以下「利用者」という。）が遵守すべき事項および利用者と当社との関係を定めるものです。</li>
              <li>利用者は、本規約の他、本規約に付随して当社が定める規定、各種ガイドライン、マニュアル等（以下総称して「本規約等」といい、本アプリの利用規約を含みます。）を遵守するものとします。</li>
              <li>本サービスの対象コンテンツは、全てマイSS運営店（対象コンテンツの提供者。以下「対象コンテンツ提供者」といいます。）が利用者に対して直接提供するものであって、当社が提供するものではありません。対象コンテンツに関し、対象コンテンツ提供者と利用者との間で万が一トラブルが生じた場合には、利用者と対象コンテンツ提供者との間で解決していただくことになります。</li>
              <li>利用者が本規約等に違反した場合、当社は当該利用者に対し、サービス提供の停止、利用資格の取消、本アプリの利用資格の取消し、その他当社が必要と判断する一切の措置を講じることができるものとします。</li>
              <li>当社は、利用者が本サービスを利用した場合、当該利用者は本規約等に同意したものとみなします。</li>
              <li>利用者は、本サービス利用に先立ち、本アプリ上でマイSSを選択する必要があります。本サービスは利用前にご利用対象店舗として指定したマイSS運営店でのみ利用が可能です（本アプリ上で選択できる全てのサービスステーションが本サービスの利用対象となるわけではなく、一部のサービスステーションでは本サービスを利用できません）。</li>
              <li>利用者は、本サービスの利用中に本アプリ上でマイSSを変更することができます。ただし、マイSSを変更した場合、本サービスや対象コンテンツを変更後のマイSSで利用することはできないためご注意ください。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第2条（適用）</h3>
            <ol class="ol-count fs13">
              <li>本規約は、本サービスの利用に関する当社との間の一切の関係に適用されます。本規約の内容に同意しない場合、本サービスを利用することはできません。</li>
              <li>利用者が、本アプリにおいて本サービスを利用する場合には、本アプリへのメールアドレス登録および車検証QRの読込による車検証の登録が必要になります。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第3条 （本サービスの内容） </h3>
            <ol class="ol-count fs13">
              <li>当社は、本規約に基づき、利用者に対して本サービスを提供します。</li>
              <li>利用者が、前項に基づき販売されたサービス利用権を利用して、対象コンテンツ提供者から対象コンテンツの提供を受けるためには、当社及び対象コンテンツ提供者所定の手続に従い、対象コンテンツ提供者との間で対象コンテンツを受ける合意をすることが必要です。なお、対象コンテンツ契約は、本サービス契約者と対象コンテンツ提供者との間で直接成立し、当社は、対象コンテンツ契約に関して責任を負いません。</li>
              <li>本規約等において、利用者が受けることができる本サービスのオイルプランの対象コンテンツ内容は、次の通りとします。
                <p class="mb0">1） 車検6ヶ月後および18ヶ月後の定期点検の無料実施。点検の際に発生する整備・作業料は有料となります。整備・作業を実施する際は利用者の同意の上で実施します。</p>
                <p class="mb0">2） 車検実施から12カ月後の法定12カ月点検の無料実施。点検の際に発生する整備・作業料は有料となります。整備・作業を実施する際は利用者の同意の上で実施します。</p>
                <p class="mb0">3） 毎点検時のオイル交換の無料実施</p>
                <p class="mb0">4） 毎月の洗車プリペイドポイント500ポイントの付与</p>
                <p class="mb0">5） 毎月のハイオク、レギュラーと軽油の1リットル当たり1円の給油割引権利の付与。なお割引権利は毎月100Lまでを上限とします。</p>
              </li>
              <li>利用者は、本アプリ上で本サービスの契約を行った後、契約対象となっている自動車等（以下「対象車両」という）に対し、指定した店舗(以下、受付店舗という)で契約したサービス内容を受けられます。</li>
              <li>本サービスの対象となる自動車は、自家用乗用車とします。ただし、自家用乗用車であってもトヨタ、ホンダ、日産、マツダ、スバル、スズキ、ダイハツ、三菱自動車以外のメーカー(外車等を含む)、乗車定員11人以上の自動車、乗車定員10人以下で車両総重量8トン以上の自動車、レンタカーおよび特殊自動車、また、定期点検整備の実施後において、自動車検査証に記載された使用者が変わったもの、あるいは、事業用自動車、レンタカーに該当することとなったものも除外します。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第4条 （本サービスの提供時期） </h3>
            <ol class="ol-count fs13">
              <li>当社は利用者に対し、本条で定めるサービス提供時期に基づき、サービスを提供します。</li>
              <li>本規約等において、利用者が受けることができる本サービスのオイルプラン対象コンテンツの提供時期は次の通りとします。
                <p class="mb0">1） 車検6か月後点検はサービス開始月（初回決済月）から6か月目、18か月点検はサービス開始月（初回決済月）から18か月目にサービスを提供します。</p>
                <p class="mb0">2） 車検実施から12か月後の法定12か月点検はサービス開始月（初回決済月）から12か月目にサービスを提供します。</p>
                <p class="mb0">3） オイル交換は毎回の点検時に提供します。</p>
                <p class="mb0">4） 洗車プリペイド500ポイントは毎月1日の午前4時に【コスモの公式】アプリに付与します。初回付与は初回決済後即時付与します。</p>
                <p class="mb0">5） 給油割引の1リットル1円引き、上限100Lは毎月1日に付与します。初回付与は初回決済の翌日付与します。</p>
              </li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第5条 （契約） </h3>
            <ol class="ol-count fs13">
              <li>本サービスの利用を希望する者（以下「申込者」といいます）は、本規約の内容に同意のうえ、当社所定の方法により、本サービス契約の申込みを行うものとします。なお、申込者が未成年者である場合は、本サービス契約の申込みについて法定代理人（親権者又は未成年後見人）の事前の同意を得るものとし、未成年者の申込者が申し込まれた場合、法定代理人の同意の上で申し込まれたものとみなします。</li>
              <li>申込者は、前項の申込みにあたり、サービス利用料のお支払いに利用するクレジットカード（以下「本サービス決済用カード」といいます）をアプリに登録する必要があります。なお、本サービス決済用カードは、当社が別途指定する種類のクレジットカードであり、かつ、申込者本人の名義のものに限ります。また、本サービス決済用カードについて、以下の各号に掲げる事項に同意するものとします。
                <p class="mb0">1） 本サービス決済用カードの変更を希望する場合、当社が定める方法により変更を行い、かかる変更がなされない限り、サービス利用料を届け出た本サービス決済用カードにより毎月支払うこと。</p>
                <p class="mb0">2） クレジットカード会社から当社に対して本サービス決済用カードの会員番号や有効期限の変更又は更新に関する情報が通知される場合があること。</p>
                <p class="mb0">3） クレジットカード会社との間の契約に基づき本サービス決済用カードを利用すること。</p>
              </li>
              <li>受付店舗は、申込者が本サービスの申込みを行う際の、本アプリのマイSSとなります。</li>
              <li>申込が可能となる期間は、対象車両の車検満了日の1か月前から車検満了日の1か月後（5月15日が車検満了日の場合申し込み可能期間は4月15日から6月15日まで）とします。なお、車検の有効期限が経過している車両への申込は不可となります。</li>
              <li>申込者は申込を行った後、車検満了後の翌月末までに入会金を受付店舗にて支払を行う必要があります。入会金の支払が完了した後、登録したクレジットカードで初回決済を行うことで、対象コンテンツの提供が開始されます。</li>
              <li>本サービスの契約は利用者が、当社が別に定める方法による解約を行うまで、継続します。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第6条 （解約） </h3>
            <ol class="ol-count fs13">
              <li>利用者は、当社が本アプリ上で定める方法で解約の申込みをすることにより、本サービス契約を解約できます。</li>
              <li>以下の各号のいずれかに該当すると当社が判断した場合、当社は、利用者へ通知をすることなく、本サービス契約を解約することができます。
                <p class="mb0">1） 本サービス契約の申込内容が事実に反している場合</p>
                <p class="mb0">2） 本サービス決済用カードで、サービス利用料の支払いをされない状態が3カ月以上経過した場合</p>
                <p class="mb0">3） 当社の業務の遂行に支障をおよぼすおそれのある行為を行った場合</p>
                <p class="mb0">4） 本規約等のいずれかに違反した場合</p>
                <p class="mb0">5） その他、上記各号に準ずる行為であって、合理的な根拠に基づき合理的な判断の結果、当社が不適切と判断する行為を行った場合</p>
              </li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第7条 （サービス利用料） </h3>
            <ol class="ol-count fs13">
              <li>サービス利用料は、オイルプランが月額 500 円（税込）となります。</li>
              <li>入会金は300円（税込）とし、受付店舗に直接、支払うものとします。</li>
              <li>本サービス契約が終了した月は、1 か月分の月額利用料がかかります。（加入月内での解約時も含みます。）</li>
              <li>サービス利用料は、以下の各号に定める方法で当社に支払うものとします。
                <p class="mb0">1） サービス利用料は前払となります。</p>
                <p class="mb0">2） 加入月の利用料は登録したクレジットカードで初回決済を行うことで支払うものとします。</p>
                <p class="mb0">3） 毎月末に、翌月分のサービス利用料を登録したクレジットカードで支払うものとします。なお、月末のお支払いは登録されたクレジット―カードから自動で決済されます。</p>
              </li>
              <li>サービス利用料が変更される場合、利用者に対し、第20条に定める方法によって予め通知するものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第8条 （サービス利用料の返金） </h3>
            <ol class="ol-count fs13">
              <li>利用者が解約した場合であっても原則、サービス利用料の返金は行いません。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第9条 （車両の点検、整備について） </h3>
            <ol class="ol-count fs13">
              <li>点検の予約
                <p class="mb0">1） 利用者は、受付店舗と直接、点検実施日時を取り決めるものとします。来店日時が決定した時点を以て、予約が完了したものとみなします。</p>
                <p class="mb0">2） 利用者が予約を申し込んだ受付店舗または当社から、予約内容確認または変更等のため、電話または電子メール等で連絡をすることがあります。その際に利用者が入力した連絡先が不通などで連絡がとれない場合、利用者の同意を得ることなく予約を取り消す場合があります。</p>
              </li>
              <li>点検の実施
                <p class="mb0">1） 利用者は、予約した車検実施の予定日時に、受付店舗に対象車両を直接納車するものとします。</p>
                <p class="mb0">2） 対象車両の納車後、受付店舗にて対象車両の状態確認を行い、点検の概算見積りをお伝えします。整備内容説明及び概算見積りへの利用者の同意を以て、点検実施の契約が成立したものとみなします。</p>
                <p class="mb0">3） 納車後の状態確認、または点検実施中に、対象車両が受付店舗では点検の受付ができない自動車等であることが判明した場合、点検実施をお引き受けできないことがあります。その場合、利用者は直接受付店舗と対象車両の引き取り予定日を決め、当該予定日の決められた時間に対象車両を引き取るものとします。</p>
              </li>
              <li>点検の代金<br>オイルプランにおいては、車検6ヶ月後および18ヶ月後の定期点検、および車検実施から12カ月後の法定12カ月点検の点検費用は発生しません。</li>
              <li>点検予約の取り消し
                <p class="mb0">1） 本条1項、並びに2項に基づく利用者による受付店舗への点検実施の予約、または契約の全部もしくは一部の取消し、または車検内容の変更については、受付店舗の定めによるものとし、利用者は、点検実施の予約時に、当該定めを確認するものとします。</p>
                <p class="mb0">2） 利用者が本点検予約を取消す場合は、利用者と受付店舗で合意した点検実施日の3日前までに、受付店舗に対して本条1項で定める取消しの連絡を行うものとします。</p>
                <p class="mb0">3） 本条1項の定めにより、点検の取消し、または変更に伴う費用等が発生する場合、利用者はその費用を受付店舗に直接支払うものとします。尚、点検予約の取消しができず利用者が不利益を被った場合でも当社は一切の責任を負いません。</p>
              </li>
              <li>代車の貸し出し<br>代車の貸し出しについては受付店舗の定めによるものとし、利用者は、本規約9条1項に定める点検実施の予約時に、受付店舗に確認するものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第10条 （洗車プリペイドについて） </h3>
            <p>別途定める洗車プリペイドの利用規約に準じるものとしてます。</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第11条 （給油割引について） </h3>
            <p>利用者は、本規約の第3条第4項第5号に基づいて付与される給油割引権利（以下、「本アプリの給油クーポン」という。）を利用し、受付店舗にて給油を行うことで、給油割引を受けることができます。</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第12条 （禁止事項）</h3>
            <ol class="ol-count fs13">
              <li>利用者は、本サービスの利用にあたっては、次の行為を行わないものとします。
                <p class="mb0">1） 自己の利用権を三者に利用させる行為や対象車両以外に利用する行為。</p>
                <p class="mb0">2） 本サービスにより知り得た情報を、私的利用以外の目的(営利目的等)で利用する行為、または本アプリを営業活動に利用する行為。</p>
                <p class="mb0">3） 第三者へのいやがらせ、誹謗、中傷、名誉を傷つける行為または猥褻的もしくは暴力的な行為。</p>
                <p class="mb0">4） 真実でない情報を発信する行為または当社へ情報登録を行う際に虚偽の届出をする行為。</p>
                <p class="mb0">5） 有害なコンピュータプログラムを送信する行為、本アプリを不正に改竄する行為、他人になりすます行為、当社・本サービス・第三者に危害や不利益を与える行為もしくは本サービスの運営を妨害する行為、またはそれらのおそれのある行為。</p>
                <p class="mb0">6） 当社および第三者の著作権、特許権、肖像権、商標権等の知的所有権、財産権、プライバシー権その他の権利や信用、名誉を侵害する行為またはそのおそれのある行為。</p>
                <p class="mb0">7） ID等を不正に使用しまたは使用させる行為。</p>
                <p class="mb0">8） 当社が提供する情報を当社の承諾を得ることなく改変する行為。</p>
                <p class="mb0">9） 不正の目的をもって当社が提供する本サービスを利用する行為。</p>
                <p class="mb0">10） 手段を問わず、本サービスの運営を妨害する行為。</p>
                <p class="mb0">11） 選挙活動、またはこれに類する行為、その他の政治および宗教に関する行為。</p>
                <p class="mb0">12） 本規約のいずれかの条項に違反する行為。</p>
                <p class="mb0">13） 法令に違反する行為。</p>
                <p class="mb0">14） 公序良俗に反する行為。</p>
              </li>
              <li>利用者は、前項の規定その他本規約等に違反し、当社および第三者に損害を与えた場合、当該損害を賠償するものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第13条 （利用者の責任等） </h3>
            <ol class="ol-count fs13">
              <li>利用者は、自己の責任の下で、本サービスを利用するものとします。</li>
              <li>利用者とマイSS運営店との間でトラブル、紛争等が生じた場合は、利用者とマイSS運営店との間で直接解決するものとします。</li>
              <li>利用者が本規約等に違反し、その結果、利用者または第三者に損害が生じたとしても、当社は一切の責任を負いません。</li>
              <li>当社は、本サービスその他当社のウェブサイト、サーバ、ドメイン等から送られるデータ、プログラム、コンテンツ、電子メール等に、コンピュータウィルス等の有害なものが含まれないことを保証しません。利用者は、自己のパソコン等のデバイスにウィルス対策ソフトをインストールする等、必要な予防措置を講じるものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第14条 （本サービス提供の停止） </h3>
            <ol class="ol-count fs13">
              <li>当社は、利用者が本規約等に違反した場合、もしくは次のいずれかに該当する場合、利用者に事前の通知または催告をすることなく、本サービスの提供を本サービスの提供を中止、または一時停止することができます。本サービスの提供が停止された場合であっても、付与済の洗車プリカポイントやその他コンテンツの有効期限の延長・変更は行わないものとします。また、本条に基づく中止・停止を理由とする利用者への返金等は行いません。
                <p class="mb0">1） 利用者に対して、差押、仮差押、仮処分、強制執行または破産の申立てがなされた場合</p>
                <p class="mb0">2） その他、本サービスの利用者として不適格と当社が判断した場合</p>
                <p class="mb0">3） 本サービスが不正使用されたとき、またはその疑いのあるとき</p>
                <p class="mb0">4） システムの障害その他の事由により本アプリ上で本サービスが使用不能となったとき</p>
                <p class="mb0">5） 利用者による本サービスの利用が本規約に違反し、または違反するおそれのあるとき</p>
                <p class="mb0">6） その他やむを得ない事由が生じたとき</p>
              </li>
              <li>当社は、前項の本サービス提供の停止により、利用者に損害または不利益が生じたとしても、当社の責に帰すべき事由がある場合を除き、一切責任を負わないものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第15条 （本サービスの変更、中断及び終了） </h3>
            <ol class="ol-count fs13">
              <li>当社は、次のいずれかに該当する場合、利用者に対する事前の通知を行うことなく、本サービスの全部または一部の内容を変更、中断または終了できるものとします。
                <p class="mb0">1） 本サービス提供に必要とする設備およびシステムの定期的または緊急の保守、点検もしくは更新を行う場合</p>
                <p class="mb0">2） システム障害対応またはその他技術上、運用上の理由による場合</p>
                <p class="mb0">3） 天災、火災、停電等不測の事態のために本サービスの継続的な提供が困難となった場合</p>
              </li>
              <li>当社が、営業上、運用上もしくは技術上の理由により本サービスの中断もしくは終了が必要であると判断した場合、当社は、利用者が登録している本アプリまたは電子メールアドレス宛に発信する方法、または本サービスのウェブサイト内で表示する方法にて事前の通知を行うことにより、本サービスの提供を終了することができるものとします。</li>
              <li>当社は、本条により本サービスの全部または一部の提供内容を変更、中断または終了した場合、利用者または第三者が被った損害について、当社の責に帰すべき事由がある場合を除き、一切の責任を負わないものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第16条 （個人情報） </h3>
            <p>本サービスの利用にあたって利用者が当社に対して個人情報を提供した場合、当社は、別途定める「【コスモの公式】アプリプライバシーポリシー」に従い取り扱うものとし、利用者はこれに同意するものとします。</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第17条 （免責事項） </h3>
            <p>本サービスの利用に際して、利用者が被った損害について当社が責任を負う場合であっても、当社の故意または重過失がある場合を除き、当社の責任は直接かつ通常の損害に限られるものとします。</p>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第18条 （損害賠償） </h3>
            <ol class="ol-count fs13">
              <li>利用者が本規約等に違反した場合、または利用者の故意・過失により当社に損害や費用負担を生じさせた場合、利用者は当社に対して発生した損害または費用（弁護士費用を含む）を賠償する義務を負うものとします。</li>
              <li>利用者は、本サービス利用によって第三者に対して損害を与えた場合、自己の責任において解決し、当社に損害を与えないものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第19条 （規約の改定） </h3>
            <ol class="ol-count fs13">
              <li>当社は、次に掲げる場合、利用者から個別の同意を得ることなく当社の裁量で本利用規約を変更することができるものとします。
                <p class="mb0">1） 利用規約の変更が、利用者の一般の利益に適合する場合</p>
                <p class="mb0">2） 利用規約の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、その他の変更に係る事情に照らして合理的なものである場合</p>
              </li>
              <li>改定後の本規約等は当社が当社所定の本アプリ上または本サービスのウェブサイト上に効力発生日とともに事前に掲示します。ただし、前項1号の場合には、事前の掲示を行わないことができるものとします。</li>
            </ol>
          </section>
          <section>
            <h3 class="bdb-solid-gray3 pb4 mb8 mt24">第20条 （管轄裁判所） </h3>
            <p>本規約等は日本国内法に基づき解釈されるものとし、本サービスに関連して訴訟の必要が生じた場合には、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</p>
          </section>
        </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: [
  ],
  methods: {
  },
  async mounted () {
    this.nativePVset('MpRiyoukiyaku')
  }
}
</script>
